//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { YouTubeStateFactory } from '@youtube/routes/stateFactory';

import {
  componentNameToTemplate,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules() {
  // no-op
}

export const states = {
  youtube: YouTubeStateFactory({
    url: '/youtube?:startDate&:endDate',
    template: componentNameToTemplate('youtubePage'),
    redirectTo: 'youtube.summary',
    resolve: {
      ...lazyLoadModule(
        'curalate.youtube',
        () => import('@youtube/YouTubeApp'),
      ),
    },
  }),
  'youtube.summary': YouTubeStateFactory({
    url: '/summary',
    data: {
      title: 'YouTube Summary',
    },
    views: {
      main: {
        template: componentNameToTemplate('youtubePage'),
      },
    },
  }),
  'youtube.engagement': YouTubeStateFactory({
    url: '/engagement',
    data: {
      title: 'YouTube Engagement',
    },
    views: {
      main: {
        template: componentNameToTemplate('youtubePage'),
      },
    },
  }),
  'youtube.audience': YouTubeStateFactory({
    url: '/audience',
    data: {
      title: 'YouTube Audience',
    },
    views: {
      main: {
        template: componentNameToTemplate('youtubePage'),
      },
    },
  }),
};
